import { MemberEndorsementDTO } from '../../services/apiClient';
import { getRoles } from '../../utils/tokenUtils';
import { TableAction } from '../common/Table';
import { Check, Clock, Download, Mail, MessageSquareText, RotateCcw, Search, Star, Trash2, User, UserCog } from 'lucide-react';

interface EndorsementActionHandlers {
  onViewMemberDetails: (endorsement: MemberEndorsementDTO) => void;
  onView: (endorsement: MemberEndorsementDTO) => void;
  onDelete: (endorsement: MemberEndorsementDTO) => Promise<void>;
  onSendEmail: (member: MemberEndorsementDTO) => void;
  onViewAllEmails: (member: MemberEndorsementDTO) => void;
  onViewRecordEmails: (member: MemberEndorsementDTO) => void;
  onRestore: (endorsement: MemberEndorsementDTO) => Promise<void>;
  onApprove: (endorsement: MemberEndorsementDTO) => void;
  onChangeStatus: (endorsement: MemberEndorsementDTO) => void;
  onImpersonateMemberLogin: (endorsement: MemberEndorsementDTO) => void;
  onHandleGenerateCertificate: (endorsement: MemberEndorsementDTO) => void;
  onAddNote: (endorsement: MemberEndorsementDTO) => void;
  onViewNoteHistory: (endorsement: MemberEndorsementDTO) => void;
}
const createEndorsementActions =
  (handlers: EndorsementActionHandlers) =>
    (row: MemberEndorsementDTO): TableAction[] => {
      const actions: TableAction[] = [];

      if (!row.isDeleted) {
        actions.push({
          label: 'View Member',
          onClick: () => handlers.onViewMemberDetails(row),
          icon: <User className="w-4 h-4" />,
        });
      }

      if (!row.isDeleted && handlers.onView) {
        actions.push({
          label: 'View Record',
          onClick: () => handlers.onView(row),
          icon: <Search className="w-4 h-4" />,
        });

        if (row.status?.title?.toLowerCase().includes('approved')) {
          actions.push({
            label: 'Download Certificate',
            onClick: () => handlers.onHandleGenerateCertificate(row),
            icon: <Download className="w-4 h-4" />,
          });
        }

        actions.push({
          label: 'Login as Member',
          onClick: () => handlers.onImpersonateMemberLogin(row),
          icon: <UserCog className="w-4 h-4" />,
          confirmMessage: 'Are you sure you want to login as this member?',
        });


      }

      if (!row.isDeleted && handlers.onSendEmail) {
        actions.push({
          label: 'Send Email',
          onClick: () => handlers.onSendEmail(row),
          icon: <Mail className="w-4 h-4" />,
        });
      }

      if (!row.isDeleted && handlers.onViewAllEmails) {
        actions.push({
          label: 'Messages(All)',
          onClick: () => handlers.onViewAllEmails(row),
          icon: <Clock className="w-4 h-4" />,
        });
      }

      if (!row.isDeleted && handlers.onViewRecordEmails) {
        actions.push({
          label: 'Messages(Record)',
          onClick: () => handlers.onViewRecordEmails(row),
          icon: <Clock className="w-4 h-4" />,
        });
      }

      if (!row.isDeleted && handlers.onAddNote) {
        actions.push({
          label: 'Create Note',
          onClick: () => handlers.onAddNote(row),
          icon: <MessageSquareText className="w-4 h-4" />,
        });
      }

      if (!row.isDeleted && handlers.onViewNoteHistory) {
        actions.push({
          label: 'Notes History',
          onClick: () => handlers.onViewNoteHistory(row),
          icon: <MessageSquareText className="w-4 h-4" />,
        });
      }


      if (!row.isDeleted && handlers.onApprove) {
        actions.push({
          label: 'Approve',
          onClick: () => handlers.onApprove(row),
          icon: <Check className="w-4 h-4" />,
          className: 'text-green-600 hover:text-green-700',
        });
      }
      if (!row.isDeleted && handlers.onChangeStatus) {
        actions.push({
          label: 'Change Status',
          onClick: () => handlers.onChangeStatus(row),
          icon: <Star className="w-4 h-4" />,
          className: 'text-orange-600 hover:text-orange-700',
        });
      }



      if (row.isDeleted) {
        actions.push({
          label: 'Restore Deleted',
          onClick: () => handlers.onRestore(row),
          icon: <RotateCcw className="w-4 h-4" />,
          confirmMessage: 'Are you sure you want to restore this rpl?',
          className: 'text-green-600 hover:text-green-700',
        });
      } else {
        actions.push({
          label: 'Delete Record',
          onClick: () => handlers.onDelete(row),
          icon: <Trash2 className="w-4 h-4" />,
          confirmMessage: 'Are you sure you want to delete this rpl?',
          className: 'text-red-600 hover:text-red-700',
        });
      }

      return actions;
    };

export default createEndorsementActions;
